/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

/**
 * Declare Variable
 */
const defaultState = {
  soldOutItems: null,
  soldOutCanContinue: false,
  soldOutInventory: null,
  displaySoldOutDialog: {
    footer: false,
    takeawayPaymentSummary: false,
  },
}

/**
 * Export
 */
export const soldOut = handleActions({

  UPDATE_SOLD_OUT_ITEMS: (state, action) => {
    return update(
      state,
      { soldOutItems: { $set: action.payload.soldOutItems } }, // > action.payload.soldOutItems (array)
    )
  },
  UPDATE_SOLD_OUT_CAN_CONTINUE_ACTION: (state, action) => {
    return update(
      state,
      { soldOutCanContinue: { $set: action.payload.soldOutCanContinue } },
    )
  },
  UPDATE_SOLD_OUT_INVENTORY: (state, action) => {
    return update(
      state,
      { soldOutInventory: { $set: action.payload.soldOutInventory } }, // > action.payload.soldOutInventory (object)
    )
  },

  UPDATE_DISPLAY_SOLD_OUT_DIALOG_FOOTER: (state, action) => {
    return update(
      state,
      { displaySoldOutDialog: { footer: { $set: action.payload.display } } }, // > action.payload.display (bool)
    )
  },

  UPDATE_DISPLAY_SOLD_OUT_DIALOG_TAKEAWAY_PAYMENT_SUMMARY: (state, action) => {
    return update(
      state,
      { displaySoldOutDialog: { takeawayPaymentSummary: { $set: action.payload.display } } }, // > action.payload.display (bool)
    )
  },

}, defaultState)

export default {
  soldOut,
}



// WEBPACK FOOTER //
// ./src/reducers/components/soldOut.js